require('new_design/common/cookie-copy');
